<!--
 * @Description: 合同查询
 * @Author: 
 * @Date: 2020-08-17 15:52:03
 * @LastEditors: hexy
 * @LastEditTime: 2024-03-25 15:23:59
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div v-show="showCardNav">
          <div class="search">
            <span style="display: inline-block; margin-left: 24px">
              <span style="display: inline-block; margin-right: 12px">原物料类型：</span>
              <el-select ref="collaborationUnitName" v-model="tableParam.rawTypeId" placeholder="请选择">
                <el-option v-for="(item, index) in checkTypeIdList" :key="index" :label="item.itemName" :value="item.id"></el-option>
              </el-select>
            </span>
            <span style="display: inline-block; margin-left: 24px">
              <span style="margin-right: 12px">站点名称：</span>
              <el-input v-model="tableParam.name" style="width: 180px; min-width: 150px; max-width: 220px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
            </span>
            <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="gettableData">查 询</el-button>
            <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="init()">重 置</el-button>
          </div>
        </div>
        <div class="hr"></div>
        <div class="card" style="padding-top: 10px">
          <div v-loading="tableLoading" class="card_info" :style="{ height: screenHeight - 450 }">
            <el-table
              :header-cell-style="{ background: '#f3f6f9' }"
              :cell-style="{ borderRight: 'none' }"
              border
              stripe
              style="width: 100%"
              :height="screenHeight - 450"
              :data="tableData"
              tooltip-effect="dark"
              :span-method="spanMethod"
              @selection-change="handleSelectionChange"
            >
              <template v-for="(item, index) in table">
                <el-table-column v-if="item.status" :key="index" :label="item.label" align="center" :min-width="item.width" :fixed="item.fixed" :prop="item.prop" :sortable="item.sortable">
                  <template slot-scope="scope">
                    <div v-if="item.label == '合同编号' || item.label == '招标编号' || item.label == '联系人' || item.label == '联系电话' || item.label == '合同有效期'">
                      <span style="color: yellowgreen" @click="goContract(scope.row)">{{ scope.row[item.prop] }}</span>
                    </div>
                    <span v-else>{{ scope.row[item.prop] || "-" }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { getDicType } from "@/api/common.js";
export default {
  components: {},
  mixins: [mixin],
  data() {
    return {
      /*表格增删改查及下载接口*/
      // queryPage: queryPage,
      // DownloadURL: Download,
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      show: false,
      fromDate: {},
      checkTypeIdList: [],
      table: [
        { label: "合同类型", width: "160", prop: "name", status: true, fixed: "left", sortable: false },
        { label: "合同ID", width: "120", prop: "id", status: true, sortable: false },
        { label: "合同签订主体", width: "150", prop: "deviation", status: true, sortable: false },
        { label: "供应商", width: "150", prop: "deviationName", status: true, sortable: false },
        { label: "站点名称", width: "120", prop: "deviation", status: true, sortable: false },
        { label: "合同编号", width: "150", prop: "deviationNo", status: true, sortable: false },
        { label: "招标编号", width: "120", prop: "deviation", status: true, sortable: false },
        { label: "联系人", width: "120", prop: "deviation", status: true, sortable: false },
        { label: "联系电话 ", width: "120", prop: "deviation", status: true, sortable: false },
        { label: "合同有效期", width: "120", prop: "deviation", status: true, sortable: false },
        { label: "协作单位", width: "120", prop: "deviation", status: true, sortable: false },
        { label: "协作单位合同编号", width: "150", prop: "", status: true, sortable: false },
      ],
      tableData: [
        { name: "胶凝材料", id: 1, deviationName: 222 ,deviationNo:2},
        { name: "胶凝材料", id: 2, deviationName: 44,deviationNo:3 },
        { name: "胶凝材料", id: 6, deviationName: 44 ,deviationNo:6},
        { name: "胶凝材料", id: 3, deviationName: 55 ,deviationNo:6},
        { name: "砂石", id: 5, deviationName: 3 ,deviationNo:4},
        { name: "砂石", id: 4, deviationName: 4,deviationNo:5 },
      ],
      testPosition1: 0,
      testArr1: [],
    };
  },
  created() {
    this.buttonlist = JSON.parse(window.sessionStorage.getItem("buttonlist"));
    //   this.tableParam = { ...this.tableParam, };
    //   this.gettableData();
    getDicType({ code: "MATtype" }).then(res => {
      this.checkTypeIdList = res.data.items; //
    });
    this.rowspan(this.tableData, this.testArr1, this.testPosition1, "name,firstName,secondName,contractName");

    // this.getRowList()
  },

  methods: {
    // 跳转对应的合同页面
    goContract(item) {
      console.log(item)
      if (item.name == "胶凝材料") {
        this.$router.push({ name: "GHnumberContractcontract", query: { query: item } });
      } else {
        alert("dd");
      }
    },
    init() {
      this.gettableData();
    },
    // 判断哪些需要合并
    rowspan(originalArr, spanArr, position, spanName) {
      let spanNameArr = spanName.split(',');
      if (spanNameArr.length > 1) {
        originalArr.forEach((item, index) => {
          if (index === 0) {
            spanArr.push(1);
            position = 0;
          } else {
            if (
              originalArr[index][spanNameArr[0]] ===
              originalArr[index - 1][spanNameArr[0]] &&
              originalArr[index][spanNameArr[1]] ===
              originalArr[index - 1][spanNameArr[1]]
            ) {
              spanArr[position] += 1;
              spanArr.push(0);
            } else {
              spanArr.push(1);
              position = index;
            }
          }
        })
      } else {
        originalArr.forEach((item, index) => {
          if (index === 0) {
            spanArr.push(1);
            position = 0;
          } else {
            if (
              originalArr[index][spanName] ===
              originalArr[index - 1][spanName]
            ) {
              spanArr[position] += 1;
              spanArr.push(0);
            } else {
              spanArr.push(1);
              position = index;
            }
          }
        });
      }
    },
     // 单元格合并
     spanMethod({ row, column, rowIndex, columnIndex }) {
      console.log(row,columnIndex)
      if (
        // column.label == '项目编码' ||
        column.label == '合同类型' ||
        column.label == '供应商' ||
        column.label == '合同编号' 
        ) {
        const _row = this.testArr1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogBlock {
  display: flex;
  .dialogHistory1 {
    overflow-y: auto;
    height: calc(45vh - 140px);
  }
  .dialogHistory2 {
    margin-left: 50px;
    .title {
      font-size: 18px;
      margin: 10px 0;
    }
  }
}
.control {
  display: flex;
  justify-content: space-around;
  > div {
    width: 300px;
    height: 400px;
    border-radius: 5px;
    border: 1px solid #e1e5ed;
    .control-title {
      font-size: 14px;
      color: #000;
      font-weight: bold;
      background: #e1e5ed;
      @include discen;
      height: 48px;
    }
  }
}
.dialoginfo-title {
  > div {
    cursor: pointer;
  }
  height: 48px;
  display: flex;
  background: linear-gradient(180deg, rgba(250, 252, 255, 1) 0%, rgba(245, 247, 250, 1) 100%);
  .none {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border-bottom: 1px solid #e1e5ed;
    > div {
      line-height: 48px;
      border-bottom: 1px rgba(0, 0, 0, 0) solid;
    }
  }
  .active {
    font-weight: bold;
    height: 48px;
    @include discen;
    width: calc(100% / 2);
    border: 1px solid #e1e5ed;
    border-bottom: 0;
    background: #ffffff;
    > div {
      color: $bg_color;
      line-height: 48px;
      border-bottom: 1px $bg_color solid;
    }
  }
}
.fixed-btn {
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 100%;
  margin-top: 20px;
  background: #fff;
  border-top: 1px solid #ccc;
  button {
    width: 100%;
  }
}
.dialoginfo-info {
  padding: 20px 20px 0 0px;
  overflow: auto;
  height: calc(85vh - 428px);
  .el-select,
  .el-input,
  .el-date-picker {
    width: 100%;
  }
}
.radio {
  overflow: auto;
  height: calc(100vh - 533px);
  width: 320px;
  .el-radio {
    margin-right: 0px;
  }
  padding: 20px;
  .radio-bg {
    width: 100%;
    height: 28px;
  }
  i {
    color: #808080;
    margin-left: 5px;
  }
  i:hover {
    color: $bg_color;
  }
}
.price-table1 {
  display: flex;
  justify-content: space-between;
  > div {
    width: 49%;
  }
}
.show {
  padding: 0 !important;
  .el-input,
  .el-select {
    width: 227px;
  }
  .dialoginfo {
    padding: 0;
  }
  .form-title {
    font-size: 18px;
    margin: 10px 0;
  }
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
  font-weight: 600;
}
.el-input,
.el-select {
  width: 240px;
}
.project-name {
  font-size: 18px;
}
.accout-container {
  margin: 10px 0;
  .accout-list {
    margin: 10px 0;
  }
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.no-data {
  text-align: center;
}
.financialCode {
}
.text-btn {
  color: $bg_color;
}
</style>
